export function adaptArchiveSection(
  entry: Record<string, unknown>,
  _baseUrl: string,
): Record<string, unknown> {
  return {
    sectionId: (entry['htmlId'] as string) ?? '',
    background: (entry['background'] as string) ?? '',
    overline: (entry['overline'] as string) ?? '',
    heading: (entry['heading'] as string) ?? '',
    items: Array.isArray(entry['items']) ? entry['items'] : [],
    filterCategories: Array.isArray(entry['filterCategories']) ? entry['filterCategories'] : [],
    pageSize: (entry['pageSize'] as number) ?? 9,
    cssClass: (entry['cssClass'] as string) ?? '',
    contentType: (entry['contentType'] as string) ?? '',
    footerHtml: (entry['footerHtml'] as string) ?? '',
  };
}
